// extracted by mini-css-extract-plugin
export default {"root":"root___FGx15","block":"block___PsQ0G"};